// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TUyW","question":"styles_question__e9HrW","inputVisibleButton":"styles_inputVisibleButton__2WpF8","note":"styles_note__3-Y-z"};